var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dv-active-ring-chart"},[_c('div',{ref:"active-ring-chart",staticClass:"active-ring-chart-container"}),_vm._v(" "),_c('div',{staticClass:"active-ring-info"},[_c('dv-digital-flop',{attrs:{"config":_vm.digitalFlop}}),_vm._v(" "),_c('div',{staticClass:"active-ring-name",style:(_vm.fontSize)},[_vm._v(_vm._s(_vm.ringName))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cd75252","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@jiaminghi/data-view/lib/components/activeRingChart/src/main.vue
// module id = 1541
// module chunks = 45